import api from '../api'

export const insert = async (poPreferences, homePageDomain, isLBB, country, isBillTo) => {

	

	let poRequired, beforeAfter, ccRequired, isBillToPreference
	if (poPreferences.poRequired === undefined) {
		poRequired = false
	} else {
		poRequired = poPreferences.poRequired
	}

	if (poPreferences.beforeAfter === undefined) {
		beforeAfter = false
	} else {
		beforeAfter = poPreferences.beforeAfter
	}

	if (poPreferences.ccRequired === undefined) {
		ccRequired = 3 //set it to NO, which is ID 3
	}else {
		ccRequired =  poPreferences.ccRequired
	}

	if (poPreferences.isBillToPreference === undefined) {
		isBillToPreference = true
	} else {
		isBillToPreference = poPreferences.isBillToPreference
	}

	let restType

	let payload = {
		poRequiredBefore: false
	}

	if (poPreferences.poId) {
		if (!isLBB && (country !== 'CAN' || (country === 'CAN' && isBillTo))) {
			payload.poRequiredBefore = beforeAfter
			restType = 'patch'
		} else if ((!isLBB && country === 'CAN' && !isBillTo) || isLBB) {
			payload.poRequiredBefore = beforeAfter
			payload.creditCardRulesId = ccRequired
			payload.poRequired = poRequired
			restType = 'patch'
			if (isBillToPreference) {
				payload.fleetId = homePageDomain.fleetId
				restType = 'create'
			}
		}


	}else {
		payload.poRequiredBefore = beforeAfter
		payload.creditCardRulesId = ccRequired
		payload.poRequired = poRequired
		payload.fleetId = homePageDomain.fleetId
		restType = 'create'

	}

	if (restType === 'patch') //poPreferences.poId
	{
		await api.service('billingPreferences').patch(poPreferences.poId,payload)
		/*
		 {
			poRequired: poRequired,
			poRequiredBefore: beforeAfter,
			creditCardRulesId: ccRequired,
		}
		*/
	} else {
		let ogtPoPreferenceResponse = await api.service('billingPreferences').create(payload)
		/*/
		{
			poRequired: poRequired,
			poRequiredBefore: beforeAfter,
			fleetId: homePageDomain.fleetId,
			creditCardRulesId: ccRequired,
		}*/
		await api.service('fleetLocations').patch(homePageDomain.id, {
			billingPreferenceId: ogtPoPreferenceResponse.id
		})

	}
}


// WEBPACK FOOTER //
// ./src/database/poPreferences.js